import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const getChannels = () => {
  return axiosPrivate.get('dashboard/v1/graphs/filters/graph');
};